import { TabScrollButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CollapsingTabScrollButton = styled(TabScrollButton)({
  '&.Mui-disabled': {
    width: 0,
  },
  overflow: 'hidden',
  transition: 'width 0.1s',
  width: 28,
});
